import { useState } from 'react';
import { Button } from '@/components/ui/button';

interface RenameCardModalProps {
  cardName: string;
  saving: boolean;
  onCancel: () => void;
  onConfirm: (name: string) => void;
}

export default function RenameCardModal({ cardName, saving, onCancel, onConfirm }: RenameCardModalProps) {
  const [name, setName] = useState(cardName);
  const normalizedName = name.trim();
  const unchanged = normalizedName === cardName.trim();

  return (
    <div>
      <h2 className="text-[2rem] font-semibold leading-[2.8rem] text-main">Rename card</h2>
      <p className="mt-[0.8rem] text-[1.4rem] leading-[2rem] text-second">Give this card a name to make it easier to identify.</p>

      <label className="mt-[2rem] block text-left">
        <span className="text-[1.3rem] font-medium text-main">Card name</span>
        <input
          autoFocus
          value={name}
          disabled={saving}
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && normalizedName && !unchanged && !saving) onConfirm(normalizedName);
          }}
          className="mt-[0.8rem] h-[4.4rem] w-full rounded-[0.8rem] border border-primary bg-main px-[1.2rem] text-[1.4rem] text-main outline-none placeholder:text-second focus:border-[#57E8BA]"
        />
      </label>

      <div className="mt-[2.4rem] grid grid-cols-2 gap-[1rem]">
        <Button type="button" variant="outline" size="sz44" disabled={saving} onClick={onCancel} className="w-full text-[1.3rem]">Cancel</Button>
        <Button type="button" variant="default" size="sz44" disabled={!normalizedName || unchanged || saving} onClick={() => onConfirm(normalizedName)} className="w-full text-[1.3rem]">{saving ? 'Saving...' : 'Save'}</Button>
      </div>
    </div>
  );
}
